import React from 'react';
import DragM from 'dragm';
import * as _ from 'lodash';
import { Button, Modal } from 'antd';
import styles from './CommonModal.less';


let languageMessage = null;

// TODO: 统一处理国际化
function getServiceMessage(code) {
  if (!languageMessage) {
    languageMessage = JSON.parse(localStorage.getItem('language_message'));
  }

  return languageMessage[code];
}
class ModalTitle extends React.Component {
  componentDidMount() {
    this.modalDom = document.getElementsByClassName('ant-modal-wrap');
  }

  componentWillUnmount() {
    const defaultTransformStr = 'translate(0, 0)';
    _.each(this.modalDom, (modalDom) => {
      modalDom.style.transform = defaultTransformStr;
    });
  }

  updateTransform = (transformStr) => {
    _.each(this.modalDom, (modalDom) => {
      modalDom.style.transform = transformStr;
    });
  };

  render() {
    const { title } = this.props;
    return (
      <DragM updateTransform={this.updateTransform}>
        <div>{title}</div>
      </DragM>
    );
  }
}
class CommonModal extends Modal {
  defaultFooter = [
    <Button
      key="submit"
      type="primary"
      style={this.props.isNewStyle ? { width: 80, height: 34 } : { width: 140 }}
      onClick={this.props.onOk}
    >
      {this.props.okText || getServiceMessage('common.sure')}
    </Button>,
    <Button
      key="back"
      style={this.props.isNewStyle ? { width: 80, height: 34 } : { width: 140 }}
      onClick={this.props.onCancel}
    >
      {this.props.cancelText || getServiceMessage('common.cancel')}
    </Button>
  ]

  render() {
    const { moveable, title, modalMarginTop, modalMarginLeft, isNewStyle } = this.props; // moveable 是否可拖动，默认可以
    const modalIsCenter = this.props.modalIsCenter || this.props.modalIsCenter === undefined;
    const wrapClassName = modalIsCenter ? this.props.wrapClassName : 'modal-left-position';
    const className = `${typeof this.props.modalIsCenter === 'boolean' ? 'modal-padding-zero' : ''} ${wrapClassName || ''} vertical-center-modal`;
    const renderTitle = title ? (moveable === true || moveable === undefined ? <ModalTitle title={title} /> : title) : null; // 兼容无 title 的 modal 样式问题
    const containerElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;
    const getContainer = this.props.getContainer ? this.props.getContainer : () => containerElement || document.body;

    return (
      <Modal
        {...this.props}
        className={`${this.props.className ? this.props.className : ''} ${isNewStyle ? styles.modal : ''}`}
        title={renderTitle}
        wrapClassName={className}
        centered
        maskStyle={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        getContainer={getContainer}
        footer={this.props.footer !== undefined ? this.props.footer : this.defaultFooter}
        maskClosable={false}
        style={modalIsCenter ? { ...this.props.style } : { top: modalMarginTop, left: modalMarginLeft, position: 'absolute' }}
      />
    );
  }
}

CommonModal.confirm = (props) => {
  return Modal.confirm({ ...props, className: props.className ? `${props.className} ${styles.btnChange}` : styles.btnChange });
};
export default CommonModal;
